var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcVolumeOnBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 27021",
    d: "M11.534 10.469L9.895 12.5a.6.6 0 01-.466.222H5.448a.6.6 0 00-.6.6v6.277a.6.6 0 00.6.6h4.721a.6.6 0 01.466.222l.9 1.115 3.4 4.214A.6.6 0 0016 25.373V6.632a.6.6 0 00-1.065-.377z",
    fill: "#006e94",
    stroke: "#006e94",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 27022",
    d: "M20.053 6.973a9.615 9.615 0 016.382 9.054 9.614 9.614 0 01-6.235 9",
    fill: "none",
    stroke: "#006e94",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 27023",
    d: "M19.864 12.352a4.76 4.76 0 011.73 3.675 4.759 4.759 0 01-1.677 3.631",
    fill: "none",
    stroke: "#006e94",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 1.5
  })));
}
export default SvgIcVolumeOnBlue;